var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mt-4"},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-btn',{attrs:{"block":"","color":"error"},on:{"click":_vm.voltar}},[_c('v-icon',[_vm._v("mdi-chevron-left")]),_vm._v(" Etapa Anterior")],1)],1),_c('v-col',{attrs:{"cols":"6"}},[_c('e-censo-dialog-texto')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }